import React, { useEffect, useMemo } from "react";
import { Modal } from "react-bootstrap";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import {ModalProgressBar} from "../../../../../_metronic/_partials/controls";
import * as actions from "../../_redux/incidents/Actions";
import {useCustomersUIContext} from "../UIContext";

export function Cancel({ id, history, show, onHide }) {
  // Customers UI Context
  const customersUIContext = useCustomersUIContext();
  const customersUIProps = useMemo(() => {
    return {
      setIds: customersUIContext.setIds,
      queryParams: customersUIContext.queryParams
    };
  }, [customersUIContext]);

  // Customers Redux state
  const dispatch = useDispatch();
  const { isLoading } = useSelector(
    (state) => ({ isLoading: state.alert.actionsLoading }),
    shallowEqual
  );

  // if !id we should close modal
  useEffect(() => {
    // if (!id) {
    //   onHide();
    // }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  // looking for loading/dispatch
  useEffect(() => {}, [isLoading, dispatch]);

  const cancelTask = () => {
    // server request for deleting customer by id
    var body = {};
    body['danger_id'] = id;
    dispatch(actions.addData('cancel', body)).then((res) => {
      // dispatch(actions.fetchCustomers(customersUIProps.queryParams));
      // customersUIProps.setIds([]);
      // closing delete modal
      dispatch(actions.fetchAllData('single', id ))
      onHide();
    });
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      aria-labelledby="example-modal-sizes-title-lg"
    >
      {/*begin::Loading*/}
      {isLoading && <ModalProgressBar />}
      {/*end::Loading*/}
      <Modal.Header closeButton>
        <Modal.Title id="example-modal-sizes-title-lg">
          Cancel Request
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {!isLoading && (
          <span>Are you sure to want to cancel this request?</span>
        )}
        {isLoading && <span>Request this cancelling...</span>}
      </Modal.Body>
      <Modal.Footer>
        <div>
          <a onClick={(onHide)} class="btn btn-text-dark font-weight-bold mr-2">Cancel</a>
          <> </>
          <button
            type="button"
            onClick={cancelTask}
            className="btn btn-primary btn-elevate"
          >
            Yes, Proceed
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}
